import stgConfig from "../../../../config";
import axios from "axios";

import Environment from "../../buyer-experience/common/environment";

const DEV_ENV = Environment.dev();
const STAGING_ENV = Environment.staging();
const PRODUCTION_ENV = Environment.production();

const BXP_EXPRESS_ENDPOINT: { [key: string]: string } = {};
BXP_EXPRESS_ENDPOINT[PRODUCTION_ENV] = "https://www.atlassian.com/endpoint";
BXP_EXPRESS_ENDPOINT[STAGING_ENV] = `${window.location.hostname.indexOf("qa-wac") > -1
  ? "https://qa-wac.internal.atlassian.com"
  : stgConfig.stgWacInternalUrl
  }/endpoint`;
BXP_EXPRESS_ENDPOINT[DEV_ENV] = BXP_EXPRESS_ENDPOINT[STAGING_ENV];

export type Consent = {
  key: string;
  displayedText: string;
  granted: boolean;
};

export type SubscriptionKey = string;

export type Subscription = {
  key: SubscriptionKey;
  subscribed: boolean;
};

type SubsciberDetails = { [key: string]: string };

// Should match `UpdatePreferencesPayload` in `bxp-express`
type UpdatePreferencesPayload = {
  formId: string;
  site?: string;
  source?: string;
  email: string;
  locale: string;
  formUrl: string;
  subscriberDetails?: SubsciberDetails;
  consentLabelText?: string;
  consentCheckboxValue: boolean;
  privacyPolicyText?: string;
  ndaText?: string;
};

type UpdatePreferencesParams = {
  formId: string;
  site?: string;
  source?: string;
  email: string;
  locale?: string;
  paramsLocale?: string;
  formUrl: string;
  consentLabelText?: string;
  consentCheckboxValue: boolean;
  privacyPolicyText?: string;
  ndaText?: string;
};

const requiredProps = ["email", "site", "locale", "formUrl"];

class ConsentHubClient {
  config: {
    locale?: string;
    localeRequiresMarketingCommunicationOptIn?: boolean;
  };
  bxpExpressEndpoint: string;

  constructor() {
    this.config = {};

    this.bxpExpressEndpoint = BXP_EXPRESS_ENDPOINT[Environment.getEnvironment()];
  }

  /**
   * Set a user's subscriptions & consents (for a specific mailing list).
   */
  async updatePreferences(params: UpdatePreferencesParams) {
    const paramsLocale = params.paramsLocale ? params.paramsLocale : "";
    const postData: UpdatePreferencesPayload = { locale: (this.config.locale || paramsLocale), ...params };

    // eslint-disable-next-line no-prototype-builtins
    if (!requiredProps.every((prop) => postData.hasOwnProperty(prop))) {
      throw `Invalid parameters. Required: {${requiredProps.toString()}}`;
    }

    const endpoint = `${this.bxpExpressEndpoint}/preferencesV2/update`;
    const response = await axios.post(endpoint, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.status;
  }

  /**
   * Get "config" data from ConsentHub
   */
  async requestConfig() {
    return this.config = (await axios.post(
      `${this.bxpExpressEndpoint}/preferencesV2/consent-config`
    )).data;
  }
}

export default ConsentHubClient;
